import axiosInstance from "api/setupAxios";

const earningsApi = {
  getTotalEarning: async () => {
    const data = await axiosInstance.get(`/user/totalEarning`);
    return data?.data ?? data;
  },

  getAgencyEarnings: async (agencyId, query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    const { data } = await axiosInstance.get(`/agency/${agencyId}/earnings`, {
      params: {
        paginate: JSON.stringify({ pageSize, pageNumber }),
        sort: JSON.stringify([["created_at", "desc"]]),
        filter: JSON.stringify(query.filter),
      },
    });
    return data?.data ?? data;
  },

  getVendorEarnings: async (vendorId, query = {}) => {
    const { paginate = {} } = query;
    const { pageSize = 10, pageNumber = 1 } = paginate;

    const { data } = await axiosInstance.get(`/vendor/${vendorId}/earnings`, {
      params: {
        paginate: JSON.stringify({ pageSize, pageNumber }),
        sort: JSON.stringify([["created_at", "desc"]]),
        filter: JSON.stringify(query.filter),
      },
    });

    return data?.data ?? data;
  },
};

export default earningsApi;
